import { find, startsWith, replace } from "lodash";

export class CookieService {
	static setCookie(name: string, value: string, expiration: string = null) {
		let cString = `${name}=${value}; `;
		if (expiration) {
			cString = cString + `expires=${expiration}; `;
		}

		cString = `${cString}path=/; `;
		document.cookie = cString;
	}

	static getCookieValue(name: string): string {
		const nameEq = name + "=";

		const segment = find(document.cookie.split(";"),
			(part: string) => {
				return startsWith(part.trim(), nameEq);
			});

		if (!segment) { return null; }

		return replace(segment, nameEq, "").trim();
	}

	static expireCookie(name) {
		document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT ;"`;
	}
}
